export * from './chips-input.component';
export * from './chips-input.module';
